<template>
    <div class="legal pb-4">
        <div v-if="isLoading">
            Loading...
        </div>
        <div v-else v-html="legalContent"></div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isLoading: true,
            legalContent: ''
        };
    },
    watch:{
        // eslint-disable-next-line
        $route (to, from){
            this.loadContent();
        }
    },
    created(){
        this.loadContent();
    },
    methods: {
        loadContent(){

            this.isLoading = true;
            this.legalContent = '';

            this.$emit('setRateHoldTimer', false);
            this.$emit('setLeaveNotification', false);

            // redirect off of buy flow if this is coincurve merchant
            if(this.$gstate.isCoincurve()){
                window.location.href = this.$gstate.getSiteURL() + this.$route.name;
                return;
            }

            var urlstr = "static/legal/";
            switch(this.$route.name){
                case "privacy-policy":
                    urlstr += "privacy-policy.html";
                    break;
                case "terms-of-service":
                    urlstr += "terms-of-service.html";
                    break;
                case "compliance-policy":
                    urlstr += "compliance-policy.html";
                    break;
                case "refund-policy":
                    urlstr += "refund-policy.html";
                    break;
            }

            this.axios.get(urlstr)
            .then(response => {
                this.isLoading = false;
                this.legalContent = response.data;
            })
            // eslint-disable-next-line
            .catch(error => {
                this.$gstate.redirectHome(300, 0, 'legal not found');
            });
        }
    }
    
}

</script>

